import React from "react";

function NabeelMohamedSaeed() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Nabeel Mohamed Saeed</b></h2>
            <div style={{color:"#5E5550"}}>
            <h6><strong>SUMMARY</strong></h6>
            <p>
            Nabeel Saeed is the Principal and Key Founder of the firm.    
            </p>
            <p>
            In addition to achieving, with honors, a Bachelor of Arts (BA Honours), in Law and Business Administration from Oxford Brookes University in the UK (1990). Nabeel holds a Master of Commercial Law (LLM) from the University of Bristol in the UK (1994), specializing in Banking and Corporate Law 
            </p>
            <p>
            Moreover, he holds postgraduate diplomas in Banking, Corporate, Insurance and Sales Laws from the University of Bristol as well (1993). Nabeel is certified as both a Legal Investigator and Fraud Examiner when he joined the Association of Certified Fraud Examiners in the US. 
            </p>
            <p>
            In 1991, Nabeel started his law career in Bahrain. Since then, he has been admitted to both the Court of Cassation and the Constitutional Court of Bahrain. 
            </p>
            <p>
            Nabeel is a seasoned Lawyer with extensive legal experience in commercial, financial and banking law, within both, Islamic and commercial banks. Prior to founding his own law firm in 2008, Nabeel worked as the Head of the Corporate Division in Haya Rashed Al Khalifa Law Firm, one of the leading firms in the Kingdom of Bahrain. Nabeel also held positions such as the General Legal Counsel to Gulf Finance House (GFH) from its inception in 1999 until 2004. GFH is one of the major Islamic investment banks in the Middle East,.
            </p>
            <p>
            Furthermore, he previously was a Director in the Arab Asian Advisors Co. 
            </p>
            <p>
            At AAA, Nabeel principally handled M&A activities, corporate restructuring, as well as structuring Islamic financial solutions,
            </p>
            <p>
                In addition to the above, Nabeel’s career included working at the Bahrain Monetary Agency (BMA) - which is now the Central Bank of Bahrain; as Head of the Legal Affairs Unit, mainly handling regulatory matters. Nabeel was also a Legal Advisor at the Ministry of Finance and National Economy where he advised and negotiated contracts for the government of Bahrain and was the Legal Advisor on a secondment basis to a number of ministries and government owned Bahraini companies whilst working with the Ministry.
            </p>
            <p>
            Finally, Nabeel has lectured on Law at the University of Bahrain, the Bahrain Institute of Banking and Finance and the Qatar Institute for Banking and Finance.
            </p>
            <p>
            Nabeel is fluent in Arabic and English.
            </p>
            <h6><strong>CONTACT DETAILS</strong></h6>
            <p>
            Email:		nabeel@nabeelsaeed.com
            </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default NabeelMohamedSaeed;
